var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"subtitle is-6 mb-5"},[_vm._v("\n        Below are some useful documents for you to access during your tenancy.\n    ")]),_vm._v(" "),_c('TenancyNotes',{attrs:{"classes":"is-6-tablet is-3-desktop"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }